<template>
<LoadError v-if="loadError && !loadingPage" :message="loadError" @retry="loadPage" />
<template v-else>

  <div class="forgot-password-container">
    <v-card class="forgot-card glass-card" :class="{ 'mobile-card': isMobile, 'desktop-card': !isMobile }" elevation="20">
      <div class="forgot-header">
        <v-icon size="48" color="green" class="mb-2">mdi-key-variant</v-icon>
        <h1 class="forgot-title">Forgot Password</h1>
        <p class="forgot-subtitle">Reset your password securely</p>
      </div>
      <Loading v-if="loadingPage" label="Loading password reset?" />
      <v-form v-else class="forgot-form">
        <v-alert v-if="error" type="error" variant="tonal" class="error-alert mb-4">{{ error }}</v-alert>
        <v-text-field
          :disabled="emaildisabled"
          clearable
          v-model="email"
          label="Email"
          variant="outlined"
          prepend-inner-icon="mdi-email"
          class="modern-input mb-4"
          density="comfortable"
        ></v-text-field>
        <v-btn
          color="green"
          block
          size="large"
          variant="flat"
          class="login-btn mb-4"
          v-if="!emailsent"
          @click="sendEmail"
          :disabled="emailsent || loading" :loading="loading"
        >
          <v-icon left class="mr-2">mdi-send</v-icon>
          Send Email
        </v-btn>
        <div v-if="emailsent">
          <p class="info-text mb-4">We've sent you an email with a unique code. Please enter it below.</p>
          <v-text-field
            type="text"
            clearable
            v-model="ecode"
            label="Unique code"
            variant="outlined"
            prepend-inner-icon="mdi-shield-key"
            class="modern-input mb-4"
            density="comfortable"
          ></v-text-field>
          <v-text-field
            clearable
            label="New Password"
            :loading="loading"
            v-model="password"
            :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]"
            :type="show ? 'text' : 'password'"
            @click:append-inner="show = !show"
            variant="outlined"
            prepend-inner-icon="mdi-lock"
            class="modern-input mb-4"
            density="comfortable"
          ></v-text-field>
          <v-text-field
            clearable
            label="Confirm Password"
            :loading="loading"
            v-model="passwordverify"
            :rules="[rules.required]"
            :type="show ? 'text' : 'password'"
            variant="outlined"
            prepend-inner-icon="mdi-lock-check"
            class="modern-input mb-4"
            density="comfortable"
          ></v-text-field>
        </div>
        <v-btn
          color="green"
          block
          size="large"
          variant="flat"
          class="login-btn mb-2"
          @click="reset"
          :disabled="!isValidForm"
        >
          <v-icon left class="mr-2">mdi-check-circle</v-icon>
          Submit Reset
        </v-btn>
        <v-btn
          v-if="!isMobile"
          variant="text"
          color="grey darken-1"
          class="forgot-close-btn mt-2"
          @click="$emit('close')"
        >
          <v-icon left class="mr-1">mdi-close</v-icon>
          Close
        </v-btn>
      </v-form>
    </v-card>
  </div>

</template>
</template>
<script>
import { loadData } from '@/services/errors';

import creds from '@/whatsapp-tracking-361713-97a0a2bb9e20.json';
import { GoogleSpreadsheet } from '@/services/spreadsheet';
export default {
  name: 'ForgotPassword',
  props: {
    isMobile: null,
    data: null,
  },
  data() {
    return {
      loadError: '',
      loadingPage: false,
      error: null,
      unique_code: null,
      password: null,
      passwordverify: null,
      rules: {
        required: (value) => !!value || 'Required.',
      },
      show: false,
      loading: false,
      code: null,
      ecode: null,
      email: null,
      emailsent: false,
      emaildisabled: false,
      emails: null,
    };
  },
  methods: {
    async loadPage() {
      return loadData(
        this,
        async () => {
          const doc = new GoogleSpreadsheet('1_QB8JSWR_AINfhpKFLp95NjLP-uFHWd9j1dbNnk2EAk');
          await doc.useServiceAccountAuth({
            client_email: creds.client_email,
            private_key: creds.private_key,
          });

          await doc.loadInfo();

          const sheet = doc.sheetsByTitle['user_db'];
          const rows = await sheet.getRows();

          this.emails = rows.map(function (value) {
            return value.email;
          });
        },
        'loadingPage'
      );
    },

    async sendEmail() {
      if (this.loading || this.loadingPage) return;
      this.loading = true;
      try {
        if (this.emails.includes(this.email)) {
          this.error = '';
          this.code = this.makeid(16);
          const doc = new GoogleSpreadsheet('1hgKjXZsAdaesadGJn0SJ0WwoX1MLSlrIrMajWG6QEJs');

          await doc.useServiceAccountAuth({
            client_email: creds.client_email,
            private_key: creds.private_key,
          });

          await doc.loadInfo();

          const sheet = doc.sheetsByTitle['pass_reset'];

          let user_object = {
            email: this.email,
            'verification code': this.code,
          };

          await sheet.addRow(user_object);
          this.emailsent = true;
          this.emaildisabled = true;
        } else {
          this.error = 'Email not found!';
        }
      } finally {
        this.loading = false;
      }
    },
    makeid(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    },
    reset() {
      if (String(this.ecode) === String(this.code) && this.password === this.passwordverify) {
        this.error = 'Success!';
        this.$emit('success', [this.email, this.password]);
      } else {
        this.error = "Passwords don't match or code incorrect. Please try again";
      }
    },
  },
  computed: {
    isValidForm() {
      return this.password === this.passwordverify && this.ecode;
    },
  },
  async beforeMount() {
    await this.loadPage();
  },
};
</script>
<style scoped>
.forgot-password-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: none;
}

.forgot-card.glass-card {
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 24px !important;
  box-shadow:
    0 20px 40px rgba(0, 0, 0, 0.2),
    0 10px 20px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.4) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  width: 420px;
  max-width: 95vw;
  padding: 40px 32px;
}

.forgot-card.mobile-card {
  width: 98vw;
  padding: 24px 8px;
}

.forgot-header {
  text-align: center;
  margin-bottom: 24px;
}

.forgot-title {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #4CAF50, #2E7D32);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 8px 0 0 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.forgot-subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0 0 8px 0;
}

.forgot-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.modern-input {
  margin-bottom: 18px;
}

.modern-input :deep(.v-field) {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.7) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(76, 175, 80, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modern-input :deep(.v-field:hover) {
  background: rgba(255, 255, 255, 0.8) !important;
  border-color: rgba(76, 175, 80, 0.5) !important;
}

.modern-input :deep(.v-field--focused) {
  background: rgba(255, 255, 255, 0.9) !important;
  border-color: rgba(76, 175, 80, 0.8) !important;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2) !important;
}

.modern-input :deep(.v-label) {
  color: rgba(0, 0, 0, 0.6) !important;
  font-weight: 500;
}

.modern-input :deep(.v-input__control .v-field .v-field__input) {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 500;
}

.modern-input :deep(.v-icon) {
  color: rgba(76, 175, 80, 0.7) !important;
}

.login-btn {
  background: linear-gradient(135deg, #4CAF50, #2E7D32) !important;
  color: white !important;
  border-radius: 12px !important;
  font-weight: 600;
  font-size: 1rem;
  text-transform: none;
  padding: 16px !important;
  box-shadow:
    0 8px 16px rgba(76, 175, 80, 0.3),
    0 4px 8px rgba(76, 175, 80, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow:
    0 12px 24px rgba(76, 175, 80, 0.4),
    0 6px 12px rgba(76, 175, 80, 0.3) !important;
}

.login-btn:active {
  transform: translateY(0);
}

.forgot-close-btn {
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 10px !important;
  text-transform: none;
  transition: background 0.2s;
}
.forgot-close-btn:hover {
  background: rgba(76, 175, 80, 0.08) !important;
  color: #388e3c !important;
}

.info-text {
  color: rgba(0, 0, 0, 0.7);
  font-size: 1rem;
  margin-bottom: 8px;
  text-align: center;
}

.error-alert {
  border-radius: 12px !important;
  backdrop-filter: blur(10px);
  background: rgba(244, 67, 54, 0.15) !important;
  border: 1px solid rgba(244, 67, 54, 0.3) !important;
}

@media (max-width: 600px) {
  .forgot-card.glass-card {
    width: 98vw;
    padding: 18px 4px;
  }
  .forgot-title {
    font-size: 1.4rem;
  }
}
</style>